// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1AeCe","list":"styles_list__1KJOl"};